var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('GraphicsIntroSection'),_c('GraphicsSymbolSection'),_c('GraphicsSymbolTwoSection'),_c('GraphicsLogoSection'),_c('GraphicsLogoTwoSection'),_c('GraphicsTypographicSection'),_c('GraphicsTypographicThreeSection'),_c('GraphicsIconographicSection'),_c('GraphicsPhotosSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }